<template>
  <div class="html-content" v-html="content"></div>
</template>

<script setup lang="ts">
export interface Props {
  content: string;
}

defineProps<Props>();
</script>

<style lang="scss">
.html-content {
  h1 {
    color: rgb(var(--v-theme-text-primary));
    font-size: 24px;
    font-weight: 600;
    line-height: 30px;
    margin-bottom: 16px;
  }

  h2 {
    color: rgb(var(--v-theme-text-accent));
    font-size: 18px;
    font-weight: 600;
  }

  h3 {
    color: rgb(var(--v-theme-text-primary));
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }

  ul,
  ol {
    padding-left: 20px;
    color: rgb(var(--v-theme-text-primary));
    font-size: 14px;
    margin-bottom: 20px;
    font-weight: 400;
  }

  ul li {
    list-style-type: disc;
  }

  ol {
    padding-left: 25px;
  }

  p {
    font-size: 14px;
    color: rgb(var(--v-theme-text-primary));
    margin-bottom: 20px;
    font-weight: 400;
  }

  a {
    color: rgb(var(--v-theme-text-link));
  }

  img {
    max-width: 100%;
    border-radius: 20px;
    margin-top: 15px;
    margin-bottom: 15px;
    display: block;
  }

  table {
    width: 50%;
    border: 1px solid rgb(var(--v-theme-bg-secondary));
    border-collapse: collapse;
  }

  tr:not(:last-child),
  th {
    border-bottom: 1px solid rgb(var(--v-theme-bg-secondary));
  }

  th {
    text-align: left;
    padding: 5px 10px;
    color: rgb(var(--v-theme-text-secondary));
    font-size: 14px;
    font-weight: 400;
  }

  td {
    padding: 22px 10px;
    font-size: 14px;
  }

  .connectivity-warn-block {
    display: inline-block;
    position: relative;
    padding: 16px 16px 16px 50px;
    margin-bottom: 20px;
    z-index: 1;
    color: rgb(var(--v-theme-text-danger));

    &::before {
      position: absolute;
      left: 16px;
      top: 14px;
      display: block;
      height: 24px;
      content: url('/svg/warning.svg');
      z-index: 1;
    }

    &::after {
      position: absolute;
      inset: 0;
      background-color: rgb(var(--v-theme-bg-primary));
      content: '';
      border-radius: 16px;
      z-index: -1;
    }
  }
}
</style>
